import { Injectable } from '@angular/core';
import {
  EmployeeBasic,
  EmployeeListItem,
  EmployeeName,
  GetEmployeeDetailsByEmpIdQuery,
  HumanResourceApiService,
  ListEmployeesByEmpIdRqst,
  ListEmployeesByNameQuery,
} from '@xpo-ltl/sdk-humanresource';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HumanResourcesService {
  constructor(private humanResourceApiService: HumanResourceApiService) {}

  getEmployeeById(employeeId: string): Observable<EmployeeBasic> {
    const queryParams = new GetEmployeeDetailsByEmpIdQuery();
    return this.humanResourceApiService
      .getEmployeeDetailsByEmpId({ employeeId }, queryParams)
      .pipe(map((resp) => resp.employee.basicInfo));
  }

  listEmployeesById(employeeIds: string[]): Observable<EmployeeName[]> {
    const request = new ListEmployeesByEmpIdRqst();
    request.employeeId = employeeIds;
    return this.humanResourceApiService.listEmployeesByEmpId(request).pipe(map((resp) => resp.employeeNames));
  }

  listEmployeesByName(lastName: string): Observable<EmployeeListItem[]> {
    const request = new ListEmployeesByNameQuery();
    request.lastName = lastName;
    return this.humanResourceApiService
      .listEmployeesByName(request, { loadingOverlayEnabled: false })
      .pipe(map((resp) => resp.employees));
  }
}
